// This script moves the installment form (containing the "Customize" button) to appear after the variant-selects element on Shopify product pages.
// It uses querySelector with partial ID matching to make it general across different product templates.
// Run this on page load, e.g., by adding it to your theme's JavaScript file or via a script tag in theme.liquid.

document.addEventListener('DOMContentLoaded', function() {
    // Select the variant-selects element (assuming it starts with "variant-selects-")
    const variantSelects = document.querySelector('variant-selects[id^="variant-selects-"]');
    
    // Select the form element (assuming it starts with "product-form-installment-")
    const form = document.querySelector('form[id^="product-form-installment-"]');
    
    // If both elements exist, move the form to after the variant-selects
    if (variantSelects && form) {
        // Remove the form from its current position
        form.remove();
        
        // Insert the form right after the variant-selects element
        variantSelects.parentNode.insertBefore(form, variantSelects.nextSibling);
    }
});